import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "preview-block" }

import { ref, computed, onMounted, nextTick } from 'vue'
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import Question from '../models/Question'
import QuestionBodyPreviewComponent from './QuestionBodyPreviewComponent.vue'
import ExplanationPreviewComponent from './ExplanationPreviewComponent.vue'
import QuestionComponent from './QuestionComponent.vue'
import { qEditorState } from '../stores'


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionPreviewComponent',
  setup(__props) {

const topPaneSize = ref(60)
const isMounted = ref(false)

onMounted(() => {
  // Delay rendering Splitpanes to ensure DOM is ready
  nextTick(() => {
    isMounted.value = true
  })
})

const questions = computed(() => qEditorState.questions)
const question = computed(() => qEditorState.question)

const groupQuestions = computed<Question[]>(() => {
  if (!question.value) {
    return []
  }
  return questions.value.filter((q) => q.group === question.value!.group)
})

const onResized = (panes: any) => {
  if (panes?.panes?.[0]?.size !== undefined) {
    topPaneSize.value = panes.panes[0].size
  } else if (Array.isArray(panes) && panes[0]?.size !== undefined) {
    topPaneSize.value = panes[0].size
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isMounted.value)
      ? (_openBlock(), _createBlock(_unref(Splitpanes), {
          key: 0,
          horizontal: "",
          class: "default-theme preview-splitpanes",
          onResized: onResized
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Pane), {
              size: topPaneSize.value,
              "min-size": 5,
              class: "question-preview"
            }, {
              default: _withCtx(() => [
                _createVNode(QuestionComponent)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["size"]),
            _createVNode(_unref(Pane), {
              size: 100 - topPaneSize.value,
              "min-size": 5,
              class: "explain-preview"
            }, {
              default: _withCtx(() => [
                _createVNode(ExplanationPreviewComponent, { groupQuestions: groupQuestions.value }, null, 8 /* PROPS */, ["groupQuestions"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["size"])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})